import { render, staticRenderFns } from "./ReviewExtendWorkplaceAssignation.vue?vue&type=template&id=4f9418c9&scoped=true"
import script from "./ReviewExtendWorkplaceAssignation.vue?vue&type=script&lang=js"
export * from "./ReviewExtendWorkplaceAssignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9418c9",
  null
  
)

export default component.exports